/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyBillItem from './pharmacy-bill-item';
import PharmacyBillItemDetail from './pharmacy-bill-item-detail';
import PharmacyBillItemUpdate from './pharmacy-bill-item-update';
import PharmacyBillItemDeleteDialog from './pharmacy-bill-item-delete-dialog';

const PharmacyBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyBillItem />} />
    <Route path="new" element={<PharmacyBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyBillItemDetail />} />
      <Route path="edit" element={<PharmacyBillItemUpdate />} />
      <Route path="delete" element={<PharmacyBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyBillItemRoutes;
